const $0d557da401ae9ccd$var$popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
const $0d557da401ae9ccd$var$popoverList = [
    ...$0d557da401ae9ccd$var$popoverTriggerList
].map((popoverTriggerEl)=>new bootstrap.Popover(popoverTriggerEl));




//# sourceMappingURL=index.9cc37ef3.js.map
